import { render, staticRenderFns } from "./DashboardExaminationItem.vue?vue&type=template&id=36c79262"
import script from "./DashboardExaminationItem.vue?vue&type=script&lang=ts"
export * from "./DashboardExaminationItem.vue?vue&type=script&lang=ts"
import style0 from "./DashboardExaminationItem.vue?vue&type=style&index=0&id=36c79262&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports